// src/components/unauthorized.tsx
import React from "react";
import { useNavigate } from "react-router-dom";

const Unauthorized: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "100vh",
            padding: "20px"
        }}>
            <h1 style={{ fontSize: "72px", marginBottom: "20px" }}>403</h1>
            <h2 style={{ marginBottom: "10px" }}>Access Denied</h2>
            <p style={{ color: "#666", marginBottom: "30px" }}>
                You don't have permission to access this page.
            </p>
            <div style={{ display: "flex", gap: "10px" }}>
                <button onClick={() => navigate(-1)}>Go Back</button>
                <button onClick={() => navigate("/app/table")}>Go to Dashboard</button>
            </div>
        </div>
    );
};

export default Unauthorized;